import script from "./TaskElementOnMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskElementOnMainPage.vue?vue&type=script&setup=true&lang=js"

import "./TaskElementOnMainPage.vue?vue&type=style&index=0&id=7b7eab26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7eab26"]])

export default __exports__